import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../core/form/Button';
import Table from '../../../core/form/Table';
import Dialog from '../../../core/layout/Dialog';
import Row from '../../../core/layout/Row';
import Column from '../../../core/layout/Column';
import Select from '../../../core/form/Select';
import get from 'lodash/get';
import FetchSelect from '../../../core/form/FetchSelect';
import capitalize from 'lodash/capitalize';

const UsageStatsStudentListDialog = props => (
  <Dialog
    width="90%"
    isOpen={props.isOpen}
    title="Students"
    onCancel={props.onClose}
    actions={[
      <Button
        icon="close-circle"
        label="Close"
        onClick={props.onClose}
      />,
    ]}
  >
    <Row>
      <Column size={3}>
        <FetchSelect
          showSearch
          isPaginated
          url="schools"
          params={{ company: props.companyId }}
          fullWidth
          label="School"
          value={get(props.values, 'school', '')}
          onChange={schoolId => {
            props.onChange('school', schoolId);
            props.onFilter();
          }}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={2}>
        <FetchSelect
          url="academic-plans"
          fullWidth
          label="Academic Plan"
          value={get(props.values, 'academicPlan', '')}
          onChange={value => {
            props.onChange('academicPlan', value);
            props.onFilter();
          }}
          resultTransformer={{
            text: 'name',
            value: 'id',
          }}
        />
      </Column>
      <Column size={1.5}>
        <Select
          label="Status"
          value={get(props.values, 'status', '')}
          onChange={(value) => {
            props.onChange('status', value);
            props.onFilter();
          }}
          options={['TO_CHARGE', 'PLACEMENT_ONLY'].map(status => ({
            label: capitalize(status.replace(/_/g, ' ')),
            value: status,
          }))}
        />
      </Column>
    </Row>
    <Table
      rows={props.students}
      columns={[
        {
          label: 'Student',
          path: 'name',
        },
        {
          label: 'Email',
          path: 'email',
        },
        {
          label: 'School',
          path: 'school.name',
        },
        {
          label: 'Academic Plan',
          path: 'academicPlan.name',
          width: '120px',
        },
        {
          label: 'Status',
          path: 'status',
          width: '150px',
          render: status => capitalize(status.replace(/_/g, ' ')),
        },
      ]}
    />
  </Dialog>
);

UsageStatsStudentListDialog.propTypes = {
  students: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    email: PropTypes.string,
  })),
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onFilter: PropTypes.func.isRequired,
};

export default UsageStatsStudentListDialog;
